import React, { useEffect, useState } from 'react';
import './assets/css/adminlte.min.css';
import './assets/vendor/fontawesome-free/css/all.min.css' //
import './assets/css/custom.css'

import MainRoutes from './routes/Routes';
import initTreeView from './services/initTreeView';
import "primereact/resources/themes/bootstrap4-light-blue/theme.css";

import FormContext from './services/formContext';
import { getApiData } from './services/apiService';
import PreLoader from './components/parts/PreLoader';
import helpers from './services/helpers';

function App() {
    const [loading, setLoading] = useState(0);
    const [account, setAccount] = useState([]);
    const [account_loaded, setAccountLoaded] = useState(0);
    
    useEffect(() => {
        initTreeView()
        const is_authenticated = helpers.isAuthenticated();
        //Mounted

        if(is_authenticated){
          setLoading(1)
          fetchAccount();
        }
    }, []);

    async function fetchAccount(){
        let endpoint = helpers.createUrl(`V1/account/profile`)
        const data = await getApiData(endpoint)

        if(data){
            setLoading(0)
            setAccount(data.data)
            setAccountLoaded(1)
        }
    }

  useEffect(() => {
      //Mounted
      //fetchDataList()
  }, []);

  return (
    <div className="App wrapper">
      <PreLoader isLoading={loading}/>

      <FormContext.Provider value={{account}}>
        <MainRoutes />
      </FormContext.Provider>
    </div>
  );
}

export default App;
